<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal" @submit.prevent="onSubmit">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">운영자 관리</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">운영자아이디</label>
                <div class="col-sm-4">
                  <base-input placeholder="아이디" v-model="username" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">이름</label>
                <div class="col-sm-4">
                  <base-input placeholder="이름" v-model="name" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">이메일</label>
                <div class="col-sm-4">
                  <base-input placeholder="이메일" v-model="email" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">패스워드</label>
                <div class="col-sm-4">
                  <base-input type="password" placeholder="패스워드" v-model="password" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <base-button v-if="id" type="default" @click="setPassword">변경</base-button>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">권한</label>
                <div class="col-sm-4">
                  <!--                  <el-select class="select-primary" size="large" placeholder="Role" v-model="role">-->
                  <!--                    <el-option v-for="option in roles" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>-->
                  <!--                  </el-select>-->
                  <span v-for="(n, index) in roles" :key="index">
                    <base-checkbox v-model="roles[index].checked" inline>{{ n.label }}</base-checkbox>
                  </span>
                </div>
                <base-button v-if="id" type="default" @click="setRoles">권한 저장</base-button>
              </div>
            </div>
          </card>
          <base-button native-type="submit" v-if="!id" type="success">등록</base-button>
          <base-button @click="deleteAdminUser" type="danger">삭제</base-button>
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import { BaseButton, BaseInput, Card } from "@/components/index";
import { Toast } from "@/util/Toast";
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { Alert } from "@/util/Alert";

export default {
  components: {
    Card,
    BaseButton,
    BaseInput,
  },
  async created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      await this.getAdminUser();
    }
  },
  data() {
    return {
      id: null,
      username: null,
      name: null,
      email: null,
      password: null,
      role: "admin",
      roles: [
        { label: "운영", value: "admin", checked: false },
        { label: "컨텐츠운영", value: "contentAdmin", checked: false },
        { label: "언어접근권한", value: "languageAdmin", checked: false },
        { label: "마켓운영", value: "marketAdmin", checked: false },
      ],
    };
  },

  methods: {
    async getAdminUser() {
      return this.$axios.get(`/adminUsers/${this.id}`, null).then((res) => {
        const data = res.data.data;
        this.id = data.id;
        this.username = data.username;
        this.name = data.name;
        this.email = data.email;
        this.password = data.password;
        const roles = data.role.split(",");
        this.roles = this.roles.map((role) => {
          roles.forEach((r) => {
            if (r === role.value) {
              role.checked = true;
            }
          });
          return role;
        });
      });
    },

    async setPassword() {
      if (this.password.length < 8) {
        Toast.error("비밀번호를 8자이상 입력해주세요");
        return;
      }
      return this.$axios.put(`/adminUsers/${this.id}/password`, { password: this.password }).then((res) => {
        Toast.success("수정되었습니다");
        history.go(-1);
      });
    },

    async setRoles() {
      const roles = this.roles
        .filter((role) => role.checked)
        .map((role) => role.value)
        .toString();
      return this.$axios.put(`/adminUsers/${this.id}/roles`, { roles }).then((res) => {
        Toast.success("수정되었습니다");
        history.go(-1);
      });
    },

    async deleteAdminUser() {
      if (await Alert.dangerousConfirmCancel("삭제 확인", `해당 운영자를 삭제하시겠습니까?`)) {
        try {
          await this.$axios.delete(`/adminUsers/${this.id}`);
          Toast.success("삭제되었습니다");
          history.go(-1);
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },

    async onSubmit() {
      if (this.password.length < 8) {
        Toast.error("비밀번호를 8자이상 입력해주세요");
        return;
      }

      try {
        await this.$axios
          .post(`/adminUsers`, { username: this.username, name: this.name, email: this.email, password: this.password, role: this.role })
          .then((res) => {
            Toast.success("등록되었습니다");
            history.go(-1);
          });
      } catch (e) {
        showAPIErrorToast(e);
      }
    },

    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style>
.bootstrap-switch {
  margin: 6px;
}
</style>
